var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"id":"customers-archives-page"}},[_c('v-row',[_c('v-col',[_vm._v("\n\t\t\tEn cours de développement \n\t\t")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }